import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequestOtpMutationVariables = Types.Exact<{
  input: Types.RequestOtpInput;
}>;

export type RequestOtpMutation = {
  __typename?: 'Mutation';
  requestOtp: {
    __typename?: 'RequestOtpResponse';
    message: string;
    success: boolean;
  };
};

export const RequestOtpDocument = gql`
  mutation RequestOtp($input: RequestOtpInput!) {
    requestOtp(input: $input) {
      message
      success
    }
  }
`;
export type RequestOtpMutationFn = Apollo.MutationFunction<
  RequestOtpMutation,
  RequestOtpMutationVariables
>;
export function useRequestOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestOtpMutation,
    RequestOtpMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RequestOtpMutation, RequestOtpMutationVariables>(
    RequestOtpDocument,
    options,
  );
}
export type RequestOtpMutationHookResult = ReturnType<
  typeof useRequestOtpMutation
>;
export type RequestOtpMutationResult =
  Apollo.MutationResult<RequestOtpMutation>;
export type RequestOtpMutationOptions = Apollo.BaseMutationOptions<
  RequestOtpMutation,
  RequestOtpMutationVariables
>;
